
import type { Metadata } from "next";
import { Header } from "@/components/header/Header";
import InnerHero from "@/components/InnerHero/InnerHero";
import { Footer } from "@/components/Footer/Footer";
import { ContactSection } from "@/components/contactpage/ContactSection/ContactSection";
import { StudioLocation } from "@/components/contactpage/ContactSection/StudioLocation";
import { WhyChooseSection } from "@/components/WhyChooseSection/WhyChooseSection";
import { FactoryTourSection } from "@/components/FactoryTourSection/FactoryTourSection";
import { ContactFAQ } from "@/components/contactpage/ContactSection/ContactFAQ";

export const metadata: Metadata = {
  title: "Contact — Queenscraft",
  description:
    "Get in touch with Queenscraft for general enquiries, trade and wholesale, or press and partnerships.",
};

export default function ContactPage() {
  return (
    <>
      <Header />
      <main className="bg-[#0b0906]">
        <InnerHero pageKey="contact" />
        <ContactSection />
        <StudioLocation />
        <WhyChooseSection />
        <FactoryTourSection />
        <ContactFAQ />
      </main>
      <Footer />
    </>
  );
}